import { ICalendarState } from './models/ICalendarState'
import { IMandatoryFields } from './models/IMandatoryFields'
import { IUserRequestData } from './models/IUserRequestData'
import { IUserSettings } from './models/IUserSettings'
import { IUserSettingsSourcePath } from './models/IUserSettingsSourcePath'
import { TCalendarDropdowns } from './models/TCalendarDropdowns'

const IDefaultSourcePath: IUserSettingsSourcePath = {
  Domain: '',
  FormId: 0,
  Version: '',
  Name: '',
}

const userSettings: IUserSettings = {
  canCreateRequest: false,
  canDeleteRequest: false,
  canEditRequest: false,
  newRequestLimitDate: new Date(),
  isConfidentialRequestor: false,
  isShowConfirmationCheckboxes: false,
  isAutoApprover: false,
  isApprover: false,
  rejectStatusName: '',
  approveStatusName: '',
  underReviewStatusName: '',
  cancelStatusName: '',
  initialStatus: '',
  submitStatus: '',
  canCreateRequestAccess: false,
  calendarAttachmentsForm: 2125,
  plannerAttachmentsForm: 2143,
  draftAllowedStatuses: [],
  PollQuizGuideLink: '',
  sourcePaths: {
    SPActionsEventPlannerSearch: IDefaultSourcePath,
    SPAccessPlannerSaveSubscription: IDefaultSourcePath,
    SPPlannerStatuses: IDefaultSourcePath,
    SPActivityCalendarUserSettings: IDefaultSourcePath,
    Dropdown: IDefaultSourcePath,
    ActivityPlanner: IDefaultSourcePath,
    ActivityCalendarReport: IDefaultSourcePath,
    CalendarSubscriptions: IDefaultSourcePath,
    CalendarAttachments: IDefaultSourcePath,
    PlannerAttachments: IDefaultSourcePath,
    RequestsForm: IDefaultSourcePath,
    Users: IDefaultSourcePath,
    Support: IDefaultSourcePath,
    FilterValues: IDefaultSourcePath,
    ActivityCalendarExport: IDefaultSourcePath,
    SPGACSearchById: IDefaultSourcePath,
    SPGACReport: IDefaultSourcePath,
    SPGACExport: IDefaultSourcePath,
  },
  ReportColumns: [],
  ExportColumns: [],
}

const dropdownValues: TCalendarDropdowns = {
  areaOfFocus: [],
  partnerType: [],
  commercialPartnerType: [],
  contactType: [],
  retailPartnerType: [],
  audienceType: [],
  requestCategory: [],
  language: [],
  deliveryVehicle: [],
  internalRole: [],
  category: [],
  timezones: [],
  contractType: [],
  amplifyTracks: [],
  resellerType: [],
  hpAmplify: [],
  userRights: [],
  hpRole: [],
  jobFunction: [],
  campaign: [],
  markets: [],
  requestStatus: [],
  surveyResultSharing: [],
  surveyMode: [],
  RegisteredAttendeesReminderOptions: [],
  NotRegisteredAttendeesReminderOptions: [],
  commType: [],
  buyType: [],
  hpAmplifyShort: [],
  businessPartners: [],
  agreement: [],
  marketStatus: [],
}

const mandatoryFields: IMandatoryFields = {}

const userRequestData: IUserRequestData | null = null

export const initialState: ICalendarState = {
  userSettings: userSettings,
  rfbDropdowns: dropdownValues,
  userRequestData: userRequestData,
  mandatoryFields: mandatoryFields,
}
